<template>
  <div id="app">
    <Top></Top>
    <div style="display: flex; width: 100%;">
      <SideLeft></SideLeft>
      <div class="middle">
        <img class="bannerimg" src="./assets/zakopane-logo-transparent.png" />
        <div v-if="!isplaying" style="height:64px;">&nbsp;</div>
        <div v-if="isplaying" class="details-border buttonsizing info" style="line-height:2em;">
          <span>Now playing {{nowplayingname}} </span><span v-on:click="stop" class="link">
            <svg width="18px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
              <path fill="currentColor" d="M16,4.995v9.808C16,15.464,15.464,16,14.804,16H4.997C4.446,16,4,15.554,4,15.003V5.196C4,4.536,4.536,4,5.196,4h9.808C15.554,4,16,4.446,16,4.995z" />
            </svg>
          </span>
        </div>

        <div>
          <div v-on:click="getApp" class="bigbutton buttonsizing cursed" style="text-align:left;"><span style="margin-left:30px;">get app</span></div>
        </div>
        <div v-if="mountpointUrls && mountpointUrls.length>0">
          <div v-for="url in mountpointUrls" v-bind:key="url.url">
            <Channel v-on:play="play(url.url, url.name, url.title, url.artist)" :loggedIn="loggedIn" :listeners="url.listeners" :url="url.url" :name="url.name" :title="url.title" :artist="url.artist" v-on:open-vlc="openVlc(url.url)" v-on:moveto="moveto(url.name)"></Channel>
          </div>
        </div>
        <div v-if="mountpointUrls && mountpointUrls.length === 0">
          <div class="info" style="font-style:italic; font-size:x-large; margin-bottom: 30px;">No current broadcasts</div>
        </div>
        <Admin :loggedIn="loggedIn" v-on:login="login" v-on:logout="logout"></Admin>

      </div>
      <SideRight></SideRight>
    </div>
    <Bottom></Bottom>
    <audio v-if="nowplaying && nowplaying.length>0" id="player" controls style="width: 100%; margin: 2px 0; display:none;">
      <source :src="nowplaying" type="audio/ogg" />
    </audio>
    <audio id="zoiler">
      <source src="./assets/zoiler.mp4" type="audio/mp4" />
    </audio>
    <div v-if="martypartying && isPc" id="martypartcontainer">
      <video id="martyparty" src="./assets/martyparty.mp4" loop autoplay style="margin-left:auto;margin-right:auto;"></video>
    </div>
    <div v-if="bishoppartying && isPc" id="bishopcontainer" style="width:100%; display: flex; margin-top: 20px;">
      <img id="bishop" src="./assets/bishop.webp"  style="margin-left:auto;margin-right:auto;" />
    </div>
  </div>
</template>

<script lang="ts">
  import { getParser } from "bowser";
  import api from './api';
  import Channel from './components/Channel.vue';
  import Top from './components/Top.vue';
  import Bottom from './components/Bottom.vue';
  import SideLeft from './components/SideLeft.vue';
  import SideRight from './components/SideRight.vue';
  import Admin from './components/Admin.vue';


  export default {
    name: 'App',
    components: {
      Channel,
      Top,
      SideLeft,
      SideRight,
      Admin,
      Bottom
    },
    mounted: function () {
      this.updateStatus();
      setInterval(this.updateStatus, 5000);
    },
    data: function () {
      let browser = getParser(window.navigator.userAgent);
      console.log(browser);
      let browserName = browser.getBrowserName();
      if (browserName === "Chrome" || (browserName === "Microsoft Edge" && browser.getEngineName() === "Blink")) {
        var sheet = document.createElement('style');
        sheet.innerHTML = ".no-small {max-width: 800px!important;}";
        document.body.appendChild(sheet);
      }
      let res = {
        isPc: true,
        isAndroid: false,
        isIOs: false,
        appUrl: 'https://www.videolan.org/vlc/',
        openUrl: function (url) { window.open(url + ".m3u"); },
        mountpointUrls: null,
        loggedIn: api.isLoggedIn(),
        nowplaying: "",
        nowplayingname: "",
        isplaying: false,
        martypartying: false,
        bishoppartying: false
      };
      
      if (browser.getOSName() === "Android") {
        res.isPc = false;
        res.isAndroid = true;
        res.appUrl = 'https://play.google.com/store/apps/details?id=org.videolan.vlc&hl=en_AU';
        res.openUrl = function (url) { window.open(url + ".xspf", "blank"); };
      }

      if (browser.getOSName() === "iOS") {
        res.isPc = false;
        res.isIOs = true;
        res.appUrl = 'https://apps.apple.com/au/app/vlc-for-mobile/id650377962';
        res.openUrl = function (url) { window.open(url.replace("http://", "vlc://"), "blank"); };
      }

      return res;
    },
    props:
    {
    },
    methods: {
      play: function (url, name, title, artist) {
        if (this.isplaying) {
          document.getElementById('player').pause();
        }
        this.nowplaying = null;
        
        if (window.location.protocol.startsWith("https")) {
          url = url.replace("http://", "https://").replace(":8000", ":8443");
        }

        this.nowplaying = url;
        this.nowplayingname = name;

        let mp = `${url} ${name} ${title} ${artist}`.toLowerCase().includes("marty");
        this.martypartying = mp;
        if (mp) {
          setTimeout(() => document.getElementById("martyparty").play(), 100);
        }

        this.bishoppartying = `${url} ${name} ${title} ${artist}`.toLowerCase().includes("bishop") || `${url} ${name} ${title} ${artist}`.toLowerCase().includes("dan");
        
        setTimeout(() => {
          let player = document.getElementById('player');
          player.addEventListener("pause", () => this.isplaying = false);
          player.addEventListener("play", () => this.isplaying = true);
          player.play().then(r => console.log(r));
        }, 100);
      },
      stop: function () {
        this.nowplaying = null;
        this.martypartying = false;
        this.bishoppartying = false;
      },
      getApp: function () {
        this.playZoiler();
        window.open(this.appUrl, 'blank');
      },
      openVlc: function (url) {
        this.openUrl(url);

        let playDataStrings = this.mountpointUrls.map(s => `${s.url} ${s.name} ${s.title} ${s.artist}`.toLowerCase());

        if (playDataStrings.some(s => s.includes("marty")))
        {
          this.martypartying = true;
        }
        if (playDataStrings.some(s => s.includes("bishop") || s.toLowerCase().includes("dan"))) {
          this.martypartying = true;
        }

      },
      playZoiler: function () {
        document.getElementById('zoiler').play().then(r => console.log(r));
      },
      updateStatus: function () {
        api.getStatus().then(a => {

          if (!a.data.icestats.source) {
            this.mountpointUrls = [];
            this.martypartying = false;
            this.bishoppartying = false;
            return;
          }

          let sources = [];

          if (a.data.icestats.source.length && typeof (a.data.icestats.source.length) === "number") {
            sources = a.data.icestats.source;
          } else {
            sources.push(a.data.icestats.source);
          }
          this.mountpointUrls = sources.map(s => { return { url: s.listenurl, name: s.server_name, artist: s.artist, title: s.title, listeners: s.listeners }; });


          let playDataStrings = this.mountpointUrls.map(s => `${s.url} ${s.name} ${s.title} ${s.artist}`.toLowerCase());


          if (this.martypartying && !playDataStrings.some(s => s.includes("marty"))) {
            this.martypartying = false;
          }
          if (!this.martypartying && this.isplaying && playDataStrings.some(s => s.includes("marty"))) {
            this.martypartying = true;
            setTimeout(() => document.getElementById("martyparty").play(), 100);
          }


          if (this.bishoppartying && !playDataStrings.some(s => s.includes("bishop") || s.toLowerCase().includes("dan"))) {
            this.bishoppartying = false;
          }
          if (!this.bishoppartying && this.isplaying && playDataStrings.some(s => s.includes("bishop") || s.toLowerCase().includes("dan"))) {
            this.bishoppartying = true;
          }

        });
      },
      login(password) {
        if (btoa('admin:' + password) !== "YWRtaW46ZmluYWxseSBhIHphayBpIGNhbiBkbyBmcm9tIGhvbWU=") return;
        api.setPassword(password);
        this.loggedIn = true;
      },
      logout() {
        api.logout();
        this.loggedIn = false;
      },
      moveto(name) {
        if (!api.isLoggedIn()) {
          this.loggedIn = false;
          return;
        }
        let sourcename = "";
        for (let i = 0; i < this.mountpointUrls.length; i++) {
          if (this.mountpointUrls[i].name === name) {
            sourcename = this.mountpointUrls[i].url.split('/').reverse()[0];
          }
        }
        for (let i = 0; i < this.mountpointUrls.length; i++) {
          if (this.mountpointUrls[i].name !== name) {
            api.moveToMountpoint(sourcename, this.mountpointUrls[i].url.split('/').reverse()[0]);
          }
        }
      }
    }
  }
  /*!
 * SnowFlakes Cursor.js
 * - 90's cursors collection
 * -- https://github.com/tholman/90s-cursor-effects
 * -- https://codepen.io/tholman/full/oYJQZx
 */
 var snowflakeCursor = function () {
  
  var particles = [];
  
  function init() {
    bindEvents();
    loop();
  }
  
  // Bind events that are needed
  function bindEvents() {
    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mousedown', addEggplant);
    document.addEventListener('touchmove', onTouchMove);
    document.addEventListener('touchstart', onTouchMove);
    
  }

  function onTouchMove(e) {
    if( e.touches.length > 0 ) {
      for(let x = 0; x < e.touches.length; x++ ) {
        addParticle(e.touches[x].clientX + window.scrollX, e.touches[x].clientY + window.scrollY, '*');
      }
    }
  }
  
   function onMouseMove(e) {
     addParticle(e.clientX + window.scrollX, e.clientY + window.scrollY, '*');
   }
  
   function addEggplant(e) {
    var particle = new Particle();
    particle.init(e.clientX + window.scrollX - 120, e.clientY + window.scrollY - 80, "🍆", true);
    particles.push(particle);
   }

   function addParticle(x, y, character) {
    var particle = new Particle();
    particle.init(x, y, character);
    particles.push(particle);
    particle = new Particle();
    particle.init(x, y, character);
    particles.push(particle);
    particle = new Particle();
    particle.init(x, y, character);
    particles.push(particle);
    particle = new Particle();
    particle.init(x, y, character);
    particles.push(particle);
  }
  
  function updateParticles() {
    
    // Updated
    for (var i = 0; i < particles.length; i++) {
      particles[i].update();
    }
    
    // Remove dead particles
    for(let y = particles.length -1; y >= 0; y-- ) {
      if(y > 300 || particles[y].shouldDie()) {
        particles[y].die();
        particles.splice(y, 1);
      }
    }
    
  }
  
  function loop() {
    requestAnimationFrame(loop);
    updateParticles();
  }
  
  function Particle() {

    // Init, and set properties
    this.init = function(x, y, character, big = false) {
      this.velocity = {
        x:  (Math.random() < 0.5 ? -1 : 1) * (Math.random() / 2),
        y: (1 + Math.random())
      };
      
      this.lifeSpan = 60 + Math.floor(Math.random() * 60); //ms

      this.position = { x: x, y: y - window.innerHeight };

      this.element = document.createElement('span');
      this.element.innerHTML = character;
      this.element.className = "particle";
      if (big) this.element.style['fontSize'] = "180px";
      this.update();
      
      document.body.appendChild(this.element);
    };
    
    this.update = function() {
      this.position.x += this.velocity.x;
      this.position.y += this.velocity.y;
      
      this.velocity.x += (Math.random() < 0.5 ? -1 : 1) * 2 / 75;
      this.velocity.y -= Math.random() / 400;
      
      this.lifeSpan--;
      
      this.element.style.transform = "translate3d(" + this.position.x + "px," + this.position.y + "px,0) scale(" + (this.lifeSpan / 180) + ") rotate(" + (2 * this.lifeSpan) + "deg)";
    }

    this.shouldDie = function () {
      return this.lifeSpan < 1 || this.position.y > -(36 - window.scrollY) || this.position.x < 30 || this.position.x > window.innerWidth - 60;
    }
    this.die = function() {
      this.element.parentNode.removeChild(this.element);
    }
    
  }
   
  init();
}
snowflakeCursor();
</script>

<style type="text/css">
  .bannerimg{
    display:block;
    width: 100%;
    margin-bottom:-10%;
    pointer-events:none;
  }
  .buttonsizing {
    height: 50px;
    width: 90%;
    max-width: 550px;
    margin-bottom: 10px;
    border-radius: 12px;
    margin: 0 auto 20px auto;
  }
  #martypartcontainer{
    position:relative; 
    width:100%; 
    bottom:0px; 
    text-align:center; 
    margin-top: 20px;
  }
  .smaller {
    height:40px;
    margin-bottom:20px;
    font-family:candara;
  }
  .bigbutton {
    text-align: center;
    font-family: sans-serif;
    font-size: 30px;
    text-transform: uppercase;
    font-weight: 600;
    line-height: 1.7em;
    letter-spacing: .15em;
    box-shadow: inset 2px 4px 0 0 #f7cd7e;
    background: linear-gradient(180deg,#edb856 5%,#eba628);
    color: #0f3a4a;
    overflow: hidden;
  }
  .bigbutton:before {
    content: " ";
    position: absolute;
    z-index: 2;
    box-shadow: inset 0 0 6px 6px #333;
  }
  body {
    background-color: #0f3a4a;
    cursor: url("./assets/BarbieArm.png") 9 1, auto !important;
    position: absolute;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
  }
  #app{
    margin:auto;
    max-width:1200px;
    height:100%;
  }
  .no-small {
   min-width: 100px;
   align-items:center;
   align-content:space-around;
   flex-wrap:wrap;
   display: flex;
   justify-content: space-between;
   max-width: 200px;
  }

  .info {
    text-align:center;
    color: #edb856;
    font-size: large;
    font-family: sans-serif;
  }

  .details-border {
    height: 40px;
    color: #edb856;
    border: solid 2px #edb856;
    padding-bottom: 0px;
    line-height: 1.3em;
  }
  .cursed {
    cursor: url("./assets/BarbieArmFinger.png")  9 1, auto!important;
  }
  .link {
    cursor: url("./assets/BarbieArmFinger.png")  9 1, auto!important;
    text-decoration: underline;
    font-style: italic;
  }
  
  .middle {
    margin: 10px;
    margin-bottom: 100px;
  }

  .particle {
    position: absolute;
    display: block;
    pointer-events: none;
    z-index: 10000000;
    font-size: 36px;
    will-change: transform;
    color:white;
  }

  @media screen and (max-width:980px) {
   .no-small {
    display:none;
   }
   .bigbutton{
     width: 100%;
   }
  }

</style>
